module.exports = __webpack_public_path__ + "static/media/contatti.839efb8e.jpg";